import React from 'react';

import { Button, message, Upload } from 'antd';
import { RcFile, UploadChangeParam, UploadFile } from 'antd/es/upload/interface';

import { IUploadImageResponse } from './photo';

interface IUploadDocFieldProps {
  onChange?: (callbackList: Array<IFile>) => void;
  value?: Array<IFile>;
  limit?: number;
  disabled?: boolean;
  accept?: string;
  helperText?: React.ReactNode;
  getFullName?: any;
  title?: string;
}
interface IFile {
  filePath: string;
  fileName: string;
  fileFullPath?: string;
  url?: string;
}

const uploadFileAdaptor: (value?: Array<IFile>) => Array<UploadFile> = (value = []) => {
  value = value || [];
  return (
    value &&
    value.map((image, index) => {
      const constructed = {
        uid: index.toString(),
        name: image.fileName,
        status: 'done',
        url: image.fileFullPath || image.url,
        fileName: image.fileName,
        response: {
          code: 'SUCCESS',
          data: {
            filePath: image.filePath,
            fileName: image.fileName,
            url: image.fileFullPath || image.url,
          },
        },
      };
      // here some field is not needed
      return constructed as any;
    })
  );
};

/**
 * This component is just an alternative version of components/Upload.tsx without preview function
 */
export const UploadDocField = React.forwardRef<any, IUploadDocFieldProps>((props, ref) => {
  const [uploadingList, setUploadingList] = React.useState<Array<UploadFile>>([]);
  const handleBefore: (file: RcFile, FileList: Array<RcFile>) => boolean | PromiseLike<any> = (file, FileList) => {
    if (FileList.length > (props.limit ?? 100)) {
      message.error('You have exceeded the limit of images');
      return Promise.reject('You have exceeded the limit of images');
    }
    if (file.size > 30 * 1024 * 1024) {
      message.error('You have exceeded the limit of file size. Please upload video <= 30MB');
      return Promise.reject('You have exceeded the limit of file size. Please upload video <= 30MB');
    }
    return true;
  };

  const handleRemove = (file: UploadFile) => {
    if (props.value && Number(file.uid) !== -1) {
      if (props.onChange)
        props.onChange([...props.value.slice(0, Number(file.uid)), ...props.value.slice(Number(file.uid))]);
    }
    return true;
  };

  const handleChange = (info: UploadChangeParam) => {
    if (info.fileList.every(file => file.response && file.response.code === 'SUCCESS')) {
      const callbackList = info.fileList.map(files => {
        // console.log('files: ', files);
        const response: IUploadImageResponse = files.response;
        // props.getFullName(response.data);
        return {
          fileName: response.data.fileName!,
          filePath: response.data.filePath!,
          url: response.data.url! || response.data.fileFullPath!,
        };
      });
      setUploadingList([]);
      setTimeout(() => props.onChange?.(callbackList), 300);
    } else setUploadingList(info.fileList);
  };

  const uploadedList = uploadFileAdaptor(props.value);

  return (
    <>
      <Upload
        ref={ref}
        style={{ display: 'flex' }}
        showUploadList={{ showDownloadIcon: true, showRemoveIcon: true }}
        accept={props.accept}
        name="file"
        action="/merchant-service/v1/media/upload"
        listType="picture-card"
        fileList={uploadingList.length ? uploadingList : uploadedList}
        beforeUpload={handleBefore}
        disabled={(!!uploadingList.length && !uploadingList.some(file => file.status === 'error')) || props.disabled}
        onRemove={handleRemove}
        onChange={handleChange}>
        {uploadedList.length >= 1 ? null : (
          <Button style={{ border: 'none', background: 'transparent', marginRight: 10 }} disabled={props.disabled}>
            {props.title ?? 'upload'}
          </Button>
        )}
      </Upload>
      {props.helperText ? <span style={{ fontSize: '13px' }}>{props.helperText}</span> : null}
    </>
  );
});
